import { CheckboxModifier } from "./checkbox-modifier";
import { ImageModifier } from "./image-modifier";
import { FontAwesome } from "./font-awesome";
import { TinymceModifier } from "./tinymce-modifier";
import { SelectMultipleModifier } from "./select-multiple-modifier";
export class ModifiersList {
    get modifiers() {
        return [
            new CheckboxModifier(),
            new TinymceModifier(),
            new ImageModifier(),
            new SelectMultipleModifier(),
            new FontAwesome(),
        ];
    }
    applyTo(input) {
        for (const modifier of this.modifiers) {
            input.addModifier(modifier);
        }
    }
}
